import { mockBuilder } from '../utils/builderHelper.es.js';
import { CloudFile } from './CloudFile.es.js';

/** @module Mocks */ /** typedoc */
/**
 * Create an Cloud File with a download Urls
 * @returns {CloudFile}
 */
function aCloudFile() {
    return mockBuilder(new CloudFile()).withUri('downloadLink');
}

export { aCloudFile };
